/**
 * MessageDisclaimer
 *
 * Contextual info below the message editor: SMS truncation note
 * and available template variables per trigger type.
 *
 * Migrated from v2 client-reminder-message.hbs:115-164
 */

import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Typography } from 'src/components/Typography';
import { useSession } from 'src/contexts/SessionContext';

import { getVarsForTrigger } from '../automationMessageVariables';
import { AutomationItem } from '../types';

interface MessageDisclaimerProps {
  automation: AutomationItem;
  hasDefaultMessage?: boolean;
}

export const MessageDisclaimer: FC<MessageDisclaimerProps> = ({
  automation,
  hasDefaultMessage = false,
}) => {
  const { t } = useTranslation();
  const { session } = useSession();

  const smsLimit = session?.doNotTruncateSms ? 1600 : 160;
  const vars = getVarsForTrigger(automation.reminderType || '');

  return (
    <Typography variant="body2" color="text.secondary" component="div" sx={{ mt: 1 }}>
      {hasDefaultMessage
        ? t('automations.common.disclaimer.smsTruncatedWithDefault', { limit: smsLimit })
        : t('automations.common.disclaimer.smsTruncated', { limit: smsLimit })}

      {vars.length > 0 && (
        <Box sx={{ mt: 0.5 }}>
          <Trans
            i18nKey="automations.common.disclaimer.availableVars"
            values={{ vars: vars.join(', ') }}
            components={{ b: <strong /> }}
          />
        </Box>
      )}
    </Typography>
  );
};
